import type { BlockExport } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { ListBlock as ListBlockComponent } from "./ListBlock";
import { defaultData } from "./ListBlockDefaultData";
import { meta } from "./ListBlockMetaData";

export const ListBlock: BlockExport = {
  type: "component",
  Block: ListBlockComponent,
  imagePreview: {
    type: "icon",
    name: "24-list",
    size: 24,
  },
  defaultData,
  meta,
};
